// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunks/" + {"1991":"herbs-search","5948":"herbs-list"}[chunkId] + "." + chunkId + "." + {"1991":"8ef5427f08ea46cdaa98","5948":"c92f1fff32ee756bf260"}[chunkId] + ".js";
};